import { Injectable } from '@angular/core';
import { ApiClient } from '../core/api-client.service';
import { Observable } from 'rxjs';
import { GeneralApplicationInfoHolder } from './DTOs/general-application-info-holder';
import { GeneralApplicationRequest } from './DTOs/general-application-request';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {
  readonly relativeBase = "sign-up/";

  constructor(private http: ApiClient) { }


  getminorityCertificateTypes(): Observable<GeneralApplicationInfoHolder> {
    return this.http.get(this.relativeBase + "general-form-info");
  }
  submitGeneralApplication(request: GeneralApplicationRequest): Observable<boolean> {
    return this.http.put(this.relativeBase + "submit-general-application", request);
  }
}
